const ROUTES = {
  LANDING: '/',
  TR4_ENDPOINT: process.env.REACT_APP_TR4_ENDPOINT,
  OMP_ENDPOINT: process.env.REACT_APP_OMP_ENDPOINT,
  HOME: '/home',
  BUYING: '/buying',
  TR4_BUY: '/trade/list/buy',
  TRADE_DETAILS: '/trade/:tradeId?',
  TRADE_URI: '/trade/',
  PROFILE_DETAILS: '/profile/:profileId?',
  DEALER_DETAILS: '/dealer/:dealerId?',
  RESEARCH: '/research',
  SEARCH_URL: '/search',
  SEARCH: '/search/:context?',
  BID_SETTINGS: '/settings/bid',
  ACCOUNT_PROFILE: '/my-account/profile',
  ACCOUNTING: '/accounting/:page',
  ACCOUNTING_SUBSCRIPTION: '/accounting/subscription',
  PAYMENTS_ON_HOLD: '/selling/payments',
  REPORTS: '/reports/:context',
  RETAIL_TOOLS: '/settings/retail',
  SETTINGS: '/settings/transportation-default-settings',
  SUPPORT: '/support/',
  SWITCH_USER: '/user-select',
  RETAIL_BASE: '/retail/trade',
  RETAIL: '/retail/trade/:tradeId',
  RETAIL_PUBLIC_BASE: '/retail/public/',
  RETAIL_LOADING: '/retail/loading/',
  RETAIL_PUBLIC: '/retail/public/:guid',
  LOGIN: '/okta-login',
  LOGOUT: '/logout',
  OKTA_REDIRECT: '/okta-redirect',
  TIAH: '/tiah',
  TIAH_DEALER_MAP: '/tiah/dealers',
  TIAH_MOBILE_NUMBER: '/tiah/input-number',
  TIAH_MOBILE_VERIFICATION: '/tiah/verification',
  OMP_PURCHASE: '/purchases',
  OMP_BUY_CLOSING: '/trade/list/buy/closing',
  OMP_SELL_CLOSING: '/trade/list/sell/closing',
  OMP_SELL_ARRIVED: '/trade/list/sell/arrived',
  get BUYING_ACTIVE() {
    return `${this.BUYING}/active`;
  },
  get BUYING_UPCOMING() {
    return `${this.BUYING}/upcoming`;
  },
  get BUYING_PENDING() {
    return `${this.BUYING}/pending`;
  },
  get BUYING_CLOSING() {
    return `${this.BUYING}/closing`;
  },
  get BUYING_WON() {
    return `${this.BUYING}/won`;
  },
  get BUYING_ARRIVED() {
    return `${this.BUYING}/arrived`;
  },
  get BUYING_DELIVERED() {
    return `${this.BUYING}/delivered`;
  },
  get BUYING_PURCHASE() {
    return `${this.BUYING}/purchase`;
  },
  get PROFILE() {
    return `${this.PROFILE_DETAILS}${this.DEALER_DETAILS}`;
  },
  get QA() {
    return `${this.TRADE_DETAILS}/qa`;
  },
  SELLING: '/selling',
  get SELLING_PARKED() {
    return `${this.SELLING}/parked`;
  },
  get SELLING_UPCOMING() {
    return `${this.SELLING}/upcoming`;
  },
  get SELLING_ACTIVE() {
    return `${this.SELLING}/active`;
  },
  get SELLING_PENDING() {
    return `${this.SELLING}/pending`;
  },
  get SELLING_CLOSING() {
    return `${this.SELLING}/closing`;
  },
  get SELLING_WON() {
    return `${this.SELLING}/won`;
  },
  get SELLING_ARRIVED() {
    return `${this.SELLING}/arrived`;
  },
  get SELLING_DELIVERED() {
    return `${this.SELLING}/delivered`;
  },
  get SELLING_LOST() {
    return `${this.SELLING}/lost`;
  },
  get SELLING_ADESA() {
    return `${this.SELLING}/marketplace`;
  },
  get TR4_SELL() {
    return this.TR4_SELL_ACTIVE;
  },
  get TR4_SELL_PARKED() {
    return `${this.TR4_ENDPOINT}trade/list/sell/parked`;
  },
  get TR4_SELL_UPCOMING() {
    return `${this.TR4_ENDPOINT}trade/list/sell/upcoming`;
  },
  get TR4_SELL_ACTIVE() {
    return `${this.TR4_ENDPOINT}trade/list/sell/active`;
  },
  get TR4_SELL_PENDING() {
    return `${this.TR4_ENDPOINT}trade/list/sell/pending`;
  },
  get TR4_SELL_CLOSING() {
    return `${this.TR4_ENDPOINT}trade/list/sell/closing`;
  },
  get TR4_SELL_WON() {
    return `${this.TR4_ENDPOINT}trade/list/sell/won`;
  },
  get TR4_SELL_ARRIVED() {
    return `${this.TR4_ENDPOINT}trade/list/sell/arrived`;
  },
  get TR4_SELL_DELIVERED() {
    return `${this.TR4_ENDPOINT}trade/list/sell/delivered`;
  },
  get TR4_SELL_LOST() {
    return `${this.TR4_ENDPOINT}trade/list/sell/lost`;
  },
  get TR4_SELL_ADESA() {
    return `${this.TR4_ENDPOINT}marketplace/0/processing`;
  },
  get TR4_BUY_PENDING() {
    return `${this.TR4_ENDPOINT}trade/list/buy/pending`;
  },
  get TR4_BUY_CLOSING() {
    return `${this.TR4_ENDPOINT}trade/list/buy/closing`;
  },
  get TR4_BUY_WON() {
    return `${this.TR4_ENDPOINT}trade/list/buy/won`;
  },
  get TR4_BUY_ARRIVED() {
    return `${this.TR4_ENDPOINT}trade/list/buy/arrived`;
  },
  get TR4_BUY_DELIVERED() {
    return `${this.TR4_ENDPOINT}trade/list/buy/delivered`;
  },
  get TR4_BUY_ACTIVE() {
    return `${this.TR4_ENDPOINT}trade/list/buy/active`;
  },
  get TR4_BUY_UPCOMING() {
    return `${this.TR4_ENDPOINT}trade/list/buy/upcoming`;
  },
  get TR4_CREATE() {
    return `${this.TR4_ENDPOINT}editor/vin`;
  },
  CREATE: '/create',
  get TR4_RESEARCH() {
    return `${this.TR4_ENDPOINT}research`;
  },
  get TR4_LOGIN() {
    return `${this.TR4_ENDPOINT}okta-login`;
  },
  get TR4_PROFILE() {
    return `${this.TR4_ENDPOINT}${this.PROFILE_DETAILS.substring(1)}${
      this.DEALER_DETAILS
    }`;
  },
  get TR4_QA() {
    return `${this.TR4_ENDPOINT}${this.TRADE_DETAILS.substring(1)}/qa`;
  },
  get TR4_ACCOUNT_PROFILE() {
    return `${this.TR4_ENDPOINT}my-account/profile`;
  },
  get TR4_ACCOUNTING() {
    return `${this.TR4_ENDPOINT}accounting/`;
  },
  get TR4_ACCOUNTING_SUBSCRIPTION() {
    return `${this.TR4_ENDPOINT}accounting/subscription`;
  },
  get TR4_REPORTS() {
    return `${this.TR4_ENDPOINT}reports/`;
  },
  get TR4_SETTINGS() {
    return `${this.TR4_ENDPOINT}settings/transportation-default-settings`;
  },
  get TR4_SUPPORT() {
    return `${this.TR4_ENDPOINT}support/`;
  },
  get TR4_SWITCH_USER() {
    return `${this.TR4_ENDPOINT}user-select`;
  },
  get TR4_TRADE_IN() {
    return `${this.TR4_ENDPOINT}trade-in?token=`;
  },
  get OMP_TRADE_IN() {
    return `${this.OMP_ENDPOINT}trade-in?token=`;
  },
  get TR4_EDIT() {
    return `${this.TR4_ENDPOINT}editor/media/photos?tradeId=`;
  },
  get OMP_LOGOUT() {
    return `${this.OMP_ENDPOINT}loggedout?state=TRADEREV&post_logout_redirect_uri=${this.TR4_LOGIN}`;
  }
};

export default ROUTES;
